<template>
  <v-container fluid align="center" justify="center" class="py-2">
    <v-row no-gutters>
      <v-col cols="12">
        <v-card elevation="0" class="bd-main-card tw-mt-2 md:tw-mt-4">
          <div class="bd-header">
            <div class="bd-header-left">
              <div class="bd-badge">
                <v-icon color="white">mdi-chat-processing</v-icon>
              </div>
              <h2 class="bd-title">Submitted Bids</h2>
            </div>
            <v-btn
              v-if="
                ['CASH_IN_LIEU', 'WRITE_OFF', 'BELOW_EXCESS'].includes(
                  bidInfo.bookingStatus
                )
              "
              @click="
                downloadReport('VEHICLE_ASSESSMENT_REPORT', null, bookingId)
              "
              class="secondary"
              rounded
              :loading="assessmentReportLoading"
              >Assessment Report
              <v-icon class="mx-1">mdi-file-download-outline</v-icon>
            </v-btn>
          </div>
          <div
            class="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 lg:tw-grid-cols-3 tw-gap-3 py-2 px-1 md:px-3"
          >
            <detail-card
              title="Client Details"
              icon="mdi-account-outline"
              :items="clientDetails"
              :loading="loading"
            />
            <detail-card
              title="Vehicle Details"
              icon="mdi-car"
              :items="vehicleDetails"
              :loading="loading"
            />
            <detail-card
              title="Assessment Details"
              icon="mdi-clipboard-text-outline"
              :items="assessmentDetails"
              :loading="loading"
            />
            <detail-card
              title="Authorised Details"
              icon="mdi-shield-check-outline"
              :items="authorisedDetails"
              :loading="loading"
            />
            <assessment-status-checkbox
              v-if="
                ![
                  'CASH_IN_LIEU',
                  'WRITE_OFF',
                  'BELOW_EXCESS',
                  'DECLINED',
                ].includes(bidInfo.bookingStatus)
              "
              class="md:tw-col-span-2 lg:tw-col-span-2"
              :booking-id="bookingId"
            />
          </div>

          <v-card outlined elevation="0" class="reports-card mt-4">
            <div class="bd-subheader">
              <div class="bd-subbadge">
                <v-icon color="primary" size="18"
                  >mdi-file-chart-outline</v-icon
                >
              </div>
              <span class="bd-subtitle">Garage Reports</span>
            </div>
            <v-divider />
            <div class="px-3 py-3">
              <div v-if="qualifiedBidsStatus && !fullReport" class="my-2">
                <v-data-table
                  :headers="headers"
                  :items="qualifiedBids"
                  :items-per-page="10"
                  class="elevation-0 bd-table"
                >
                  <template v-slot:[`item.cost`]="{ item }">
                    {{
                      scanObject(item, 'biddingForm.repairs')
                        ? vatTotal(scanObject(item, 'biddingForm.repairs', 0)) +
                          netTotal(scanObject(item, 'biddingForm.repairs', 0)) -
                          contributionTotal(
                            scanObject(item, 'biddingForm.repairs', 0)
                          )
                        : 0 | formatCurrency
                    }}
                  </template>
                  <template v-slot:[`item.biddingFormSubmittedAt`]="{ item }">
                    {{ item.biddingFormSubmittedAt | formatToHuman }}
                  </template>
                  <template v-slot:[`item.biddingStatus`]="{ item }">
                    <v-chip
                      v-if="item.biddingStatus === 'BIDDING_TEMPLATE_SENT'"
                      small
                    >
                      Pending Bid</v-chip
                    >
                    <v-chip
                      v-else-if="item.biddingStatus === 'BIDDING_FORM_RECEIVED'"
                      color="success"
                      small
                    >
                      Bid Submitted</v-chip
                    >
                    <v-chip v-else color="success" small> nothing</v-chip>
                  </template>
                  <template v-slot:[`item.action`]="{ item }">
                    <div class="tw-flex tw-flex-row">
                      <v-icon v-if="item.winningBid" color="success"
                        >mdi-text-box-check</v-icon
                      >
                      <v-btn text @click="openGarageReport(item)"
                        ><v-icon color="primary" class="pr-1" small
                          >mdi-eye</v-icon
                        >
                        View</v-btn
                      >
                    </div>
                  </template>
                </v-data-table>
                <garage-dialog
                  :reportDialog="reportDialog"
                  :bookingId="bookingId"
                  :garageInfo="garageInfo"
                  @changeDialog="updateDialog"
                />
              </div>
              <div v-else class="my-5">
                <v-data-table
                  :headers="headers"
                  :items="bids"
                  :items-per-page="10"
                  class="elevation-0 bd-table"
                >
                  <template v-slot:[`item.cost`]="{ item }">
                    {{
                      scanObject(item, 'biddingForm.repairs')
                        ? vatTotal(scanObject(item, 'biddingForm.repairs')) +
                          netTotal(scanObject(item, 'biddingForm.repairs')) -
                          contributionTotal(
                            scanObject(item, 'biddingForm.repairs')
                          )
                        : 0 | formatCurrency
                    }}
                  </template>
                  <template v-slot:[`item.biddingFormSubmittedAt`]="{ item }">
                    {{ item.biddingFormSubmittedAt | formatToHuman }}
                  </template>
                  <template v-slot:[`item.biddingStatus`]="{ item }">
                    <v-chip
                      v-if="item.biddingStatus === 'BIDDING_TEMPLATE_SENT'"
                      small
                    >
                      Pending Bid</v-chip
                    >
                    <v-chip
                      v-else-if="item.biddingStatus === 'BIDDING_FORM_RECEIVED'"
                      color="success"
                      small
                    >
                      Bid Submitted</v-chip
                    >
                    <v-chip v-else color="success" small> nothing</v-chip>
                  </template>
                  <template v-slot:[`item.action`]="{ item }">
                    <div class="tw-flex tw-flex-row">
                      <v-icon v-if="item.winningBid" color="success"
                        >mdi-text-box-check</v-icon
                      >
                      <v-btn text @click="openGarageReport(item)"
                        ><v-icon color="primary" class="pr-1" small
                          >mdi-eye</v-icon
                        >
                        View</v-btn
                      >
                    </div>
                  </template>
                </v-data-table>
                <garage-dialog
                  :reportDialog="reportDialog"
                  :bookingId="bookingId"
                  :garageInfo="garageInfo"
                  @changeDialog="updateDialog"
                />
              </div>
            </div>
          </v-card>

          <!-- Previous Claims (loads independently of the bid data) -->
          <v-card outlined elevation="0" class="reports-card mt-4">
            <div class="bd-subheader">
              <div class="bd-subbadge">
                <v-icon color="primary" size="18">mdi-history</v-icon>
              </div>
              <span class="bd-subtitle">Previous Claims</span>
            </div>
            <v-divider />
            <div class="px-3 py-3">
              <v-skeleton-loader
                v-if="previousClaimsLoading"
                type="table-heading, table-row-divider, table-row@3"
              />
              <div v-else-if="previousClaims.length" class="my-2">
                <v-data-table
                  :headers="previousClaimsHeaders"
                  :items="previousClaims"
                  :items-per-page="5"
                  class="elevation-0 bd-table"
                >
                  <template v-slot:[`item.lossDate`]="{ item }">
                    {{ item.lossDate || '—' }}
                  </template>
                  <template v-slot:[`item.status`]="{ item }">
                    <v-chip
                      small
                      :color="claimStatusColor(item.status)"
                      text-color="white"
                    >
                      {{ item.status || 'Unknown' }}
                    </v-chip>
                  </template>
                  <template v-slot:[`item.grossClaimPaid`]="{ item }">
                    {{ formatMoney(item.grossClaimPaid) }}
                  </template>
                </v-data-table>
              </div>
              <div
                v-else
                class="tw-py-6 tw-text-center grey--text text--darken-1"
              >
                <v-icon color="grey" class="tw-mb-1"
                  >mdi-file-search-outline</v-icon
                >
                <div class="tw-text-sm">
                  No previous claims found for this vehicle.
                </div>
              </div>
            </div>
          </v-card>
        </v-card>
      </v-col>
    </v-row>

    <!-- Floating recommendation trigger (glowing) + popup -->
    <template v-if="recommendationEnabled">
      <div class="recommendation-fab">
        <div class="nudge-wrap" @click="showRecommendationDialog = true">
          <button type="button" class="nudge-btn">
            <v-icon left small color="primary">mdi-creation</v-icon>
            AI Garage Recommendation
          </button>
        </div>
      </div>

      <v-dialog
        v-model="showRecommendationDialog"
        max-width="1000"
        content-class="recommendation-dialog"
      >
        <garage-recommendation
          :recommendation="recommendation"
          :loading="recommendationLoading"
          :generating="recommendationGenerating"
          :allow-regenerate="true"
          :regenerating="recommendationRegenerating"
          @regenerate="regenerateRecommendation"
        />
      </v-dialog>
    </template>
  </v-container>
</template>

<script>
import GarageDialog from '@/components/assessment-center/bids-submitted/garageDialog'
import GarageRecommendation from '@/components/assessment-center/bids-submitted/GarageRecommendation'
import DetailCard from '@/components/assessment-center/bids-submitted/DetailCard'
import { VAT, GARAGE_RECOMMENDATION_ENABLED } from '@/utils/const'

import axios from 'axios'
import { formatToHuman } from '@/utils/time'
import { formatCurrency } from '@/utils/helpers'
import AssessmentStatusCheckbox from '@/components/assessment-center/bids-submitted/AssessmentStatusCheckbox'
import DownloadReportsMixin from '@/mixins/downloadReportsMixin'

export default {
  name: 'BidDetails',
  components: {
    AssessmentStatusCheckbox,
    GarageDialog,
    GarageRecommendation,
    DetailCard,
  },
  mixins: [DownloadReportsMixin],
  data(vm) {
    return {
      reportDialog: false,
      bids: [],
      garageInfo: '',
      loading: true,
      bookingId: vm.$route.params.bookingId,
      fullReport: vm.$route.params.fullReport || false,
      tab: null,
      biddingTemplate: null,
      bidInfo: {},
      recommendation: null,
      recommendationEnabled: GARAGE_RECOMMENDATION_ENABLED,
      recommendationLoading: true,
      recommendationGenerating: false,
      recommendationRetried: false,
      recommendationRegenerating: false,
      showRecommendationDialog: false,
      previousClaims: [],
      previousClaimsLoading: true,
      vatRate: VAT,
      previousClaimsHeaders: [
        { text: 'Claim No.', value: 'claimNo' },
        { text: 'Policy No.', value: 'polNo' },
        { text: 'Loss Date', value: 'lossDate' },
        { text: 'Description', value: 'description' },
        { text: 'Status', value: 'status' },
        { text: 'Gross Paid', value: 'grossClaimPaid', align: 'end' },
      ],
      headers: [
        {
          text: 'No.',
          align: 'start',
          sortable: false,
          value: 'garage.id',
        },
        { text: 'Garage', value: 'garage.name' },
        { text: 'Date', value: 'biddingFormSubmittedAt' },
        { text: 'Bid Cost', value: 'cost' },
        { text: 'Status', value: 'biddingStatus' },
        { text: 'Action', value: 'action' },
      ],
    }
  },
  mounted() {
    this.getBooking()
    this.getRecommendation()
  },
  computed: {
    clientDetails() {
      return [
        {
          label: 'Assessment No.',
          value: this.bookingId,
          icon: 'mdi-identifier',
        },
        {
          label: 'Claim No.',
          value: this.scanObject(this.biddingTemplate, 'claimNumber'),
          icon: 'mdi-file-document-outline',
        },
        {
          label: 'Insured Name',
          value: this.scanObject(this.bidInfo, 'clientInfo.name'),
          icon: 'mdi-account-outline',
        },
        {
          label: 'Date Created',
          value: this.bidInfo.createdAt
            ? formatToHuman(this.bidInfo.createdAt)
            : '',
          icon: 'mdi-calendar-outline',
        },
        {
          label: 'Policy No.',
          value: this.scanObject(this.bidInfo, 'policyInfo.policyNumber'),
          icon: 'mdi-shield-account-outline',
        },
      ]
    },
    vehicleDetails() {
      return [
        {
          label: 'Registration No.',
          value: this.scanObject(
            this.bidInfo,
            'vehicleInfo.registrationNumber'
          ),
          icon: 'mdi-card-text-outline',
        },
        {
          label: 'Make',
          value: this.scanObject(this.biddingTemplate, 'make'),
          icon: 'mdi-factory',
        },
        {
          label: 'Model',
          value: this.scanObject(this.biddingTemplate, 'model'),
          icon: 'mdi-car-outline',
        },
        {
          label: 'YOM',
          value: this.scanObject(this.biddingTemplate, 'yearOfManufacture'),
          icon: 'mdi-calendar-outline',
        },
        {
          label: 'Vehicle Color',
          value: this.scanObject(this.biddingTemplate, 'color'),
          icon: 'mdi-palette-outline',
        },
        {
          label: 'Engine No.',
          value: this.scanObject(this.biddingTemplate, 'engineNumber'),
          icon: 'mdi-engine-outline',
        },
        {
          label: 'Chassis No.',
          value: this.scanObject(this.biddingTemplate, 'chassisNumber'),
          icon: 'mdi-barcode',
        },
        {
          label: 'Vehicle Type',
          value: this.scanObject(this.biddingTemplate, 'bodyType'),
          icon: 'mdi-car-estate',
        },
        {
          label: 'Mileage',
          value: this.scanObject(this.biddingTemplate, 'mileage'),
          icon: 'mdi-speedometer',
        },
      ]
    },
    assessmentDetails() {
      return [
        {
          label: 'Assessment Company',
          value: this.scanObject(this.bidInfo, 'externalAssessor.name'),
          icon: 'mdi-office-building-outline',
        },
        {
          label: 'PAV',
          value:
            'KES ' +
            formatCurrency(
              this.scanObject(this.biddingTemplate, 'preAccidentValue', 0)
            ),
          icon: 'mdi-cash-multiple',
        },
        {
          label: 'Salvage Value',
          value:
            'KES ' +
            formatCurrency(
              this.scanObject(this.biddingTemplate, 'salvageValue', 0)
            ),
          icon: 'mdi-cash-refund',
        },
      ]
    },
    authorisedDetails() {
      return [
        {
          label: 'Authorised By',
          value: this.scanObject(this.bidInfo, 'authorizer.fullName'),
          icon: 'mdi-account-check-outline',
        },
        {
          label: 'Email',
          value: this.scanObject(this.bidInfo, 'authorizer.email'),
          icon: 'mdi-email-outline',
        },
      ]
    },
    qualifiedBids() {
      return this.bids.filter((item) => item.winningBid === true)
    },
    qualifiedBidsStatus() {
      return this.bids ? this.bids.some((item) => item.winningBid) : false
    },
  },
  methods: {
    getBooking() {
      axios
        .get(`/motor-assessment/api/garages/bid-forms/${this.bookingId}`)
        .then((res) => {
          if (res.data.success && res.data.data === null) {
            this.$router.push({ name: 'NotFound' })
            this.$toasted.error('Oops!...No bid Submitted', {
              duration: 3000,
            })
          }

          if (!res.data.success) {
            this.$router.push({ name: 'BidsSubmitted' })
            this.$toasted.error('Oops!...No bid Submitted', {
              duration: 3000,
            })
          }
          const response = res.data.data
          this.bids = response.garageBiddings
          this.biddingTemplate = response.biddingTemplate
          this.bidInfo = {
            clientInfo: response.clientInfo,
            vehicleInfo: response.vehicleInfo,
            policyInfo: response.policyInfo,
            createdAt: response.bookingCreatedAt,
            externalAssessor: response.externalAssessor,
            bookingStatus: response.bookingStatus,
            authorizer: response.authorizer,
          }
          this.loading = false

          // Kick off the independent previous-claims lookup once the registration
          // number is known (it comes from the booking response).
          this.getPreviousClaims(
            response.vehicleInfo && response.vehicleInfo.registrationNumber
          )
        })
    },
    getPreviousClaims(registrationNumber) {
      if (!registrationNumber) {
        this.previousClaimsLoading = false
        return
      }
      axios
        .get(
          `/motor-assessment/api/claims/previous/${encodeURIComponent(
            registrationNumber
          )}`
        )
        .then((res) => {
          this.previousClaims =
            res.data && res.data.success && Array.isArray(res.data.data)
              ? res.data.data
              : []
        })
        .catch(() => {
          this.previousClaims = []
        })
        .finally(() => {
          this.previousClaimsLoading = false
        })
    },
    formatMoney(amount) {
      return amount || amount === 0 ? 'KES ' + formatCurrency(amount) : '—'
    },
    claimStatusColor(status) {
      const value = (status || '').toLowerCase()
      if (value.includes('settled') || value.includes('closed'))
        return 'success'
      if (value.includes('reject') || value.includes('declin')) return 'error'
      if (value.includes('pending') || value.includes('open')) return 'warning'
      return 'grey'
    },
    netTotal(item) {
      return item.reduce((result, part) => {
        return result + part.unitPrice * part.quantity
      }, 0)
    },
    vatTotal(item) {
      return item
        .filter((i) => i.vat === true)
        .reduce((res, part) => {
          return res + this.getVat(part.unitPrice * part.quantity)
        }, 0)
    },
    getVat(amount) {
      return (this.vatRate / 100) * amount
    },
    contributionTotal(item) {
      const contributionRegex = /@\s*(\d+)\s*%/
      return item.reduce((res, part) => {
        let am = part.unitPrice * part.quantity
        if (part.vat) am += this.getVat(am)

        // Extract contribution percentage from part name
        const match = part.part.match(contributionRegex)
        let contribution = 0
        if (match != null && part.part.includes('CONTRIBUTION')) {
          contribution = Number(match[1])
        } else if (part.contribution != null) {
          contribution = part.contribution
        }

        return res + (contribution / 100.0) * am
      }, 0)
    },
    getRecommendation() {
      if (!this.recommendationEnabled) {
        this.recommendationLoading = false
        return
      }
      axios
        .get(`/motor-assessment/api/recommendations/${this.bookingId}`)
        .then((res) => {
          if (res.data && res.data.success && res.data.data) {
            this.recommendation = res.data.data
            this.recommendationGenerating = false
            this.recommendationLoading = false
            return
          }
          // Not ready yet — the API triggers generation in the background.
          // Show a generating state and retry once before giving up quietly.
          this.recommendationLoading = false
          if (!this.recommendationRetried) {
            this.recommendationRetried = true
            this.recommendationGenerating = true
            setTimeout(() => this.getRecommendation(), 4000)
          } else {
            this.recommendationGenerating = false
          }
        })
        .catch(() => {
          this.recommendationLoading = false
          this.recommendationGenerating = false
        })
    },
    regenerateRecommendation() {
      this.recommendationRegenerating = true
      axios
        .post(
          `/motor-assessment/api/recommendations/${this.bookingId}/generate`
        )
        .then((res) => {
          if (res.data && res.data.success && res.data.data) {
            this.recommendation = res.data.data
            this.recommendationGenerating = false
            this.$toasted.success('Recommendation regenerated', {
              duration: 3000,
            })
          } else {
            this.$toasted.error(
              (res.data && res.data.msg) ||
                'Could not regenerate recommendation',
              { duration: 3000 }
            )
          }
        })
        .catch(() => {
          this.$toasted.error('Could not regenerate recommendation', {
            duration: 3000,
          })
        })
        .finally(() => {
          this.recommendationRegenerating = false
        })
    },
    openGarageReport(item) {
      this.reportDialog = true
      this.garageInfo = item
    },
    updateDialog() {
      this.reportDialog = false
    },
  },
  filters: {
    formatCurrency,
    formatToHuman,
  },
}
</script>

<style scoped>
/* Soft-edged main card */
.bd-main-card {
  border-radius: 18px;
  border: 1px solid #e8edf5;
  background: #ffffff;
  padding: 18px 20px 20px;
}
.bd-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 12px;
}
.bd-header-left {
  display: flex;
  align-items: center;
  gap: 12px;
}
.bd-badge {
  flex: 0 0 auto;
  width: 44px;
  height: 44px;
  border-radius: 12px;
  background: linear-gradient(135deg, #034ea2 0%, #0a63c4 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 6px 16px rgba(3, 78, 162, 0.25);
}
.bd-title {
  font-size: 20px;
  font-weight: 800;
  color: #0f2a55;
  margin: 0;
}

/* Garage Reports sub-card */
.reports-card {
  border-radius: 16px;
  border: 1px solid #e8edf5 !important;
  overflow: hidden;
}
.bd-subheader {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 14px;
}
.bd-subbadge {
  flex: 0 0 auto;
  width: 32px;
  height: 32px;
  border-radius: 9px;
  background: #eaf1fb;
  display: flex;
  align-items: center;
  justify-content: center;
}
.bd-subtitle {
  font-size: 14px;
  font-weight: 700;
  color: #0f2a55;
}
.bd-table {
  border-radius: 12px;
  border: 1px solid #eef2f8;
  overflow: hidden;
}

/* Fixed floating trigger, bottom-right */
.recommendation-fab {
  position: fixed;
  right: 24px;
  bottom: 24px;
  z-index: 6;
}

/* Glowing light travelling around the button border */
.nudge-wrap {
  position: relative;
  display: inline-flex;
  padding: 2px;
  border-radius: 999px;
  overflow: hidden;
  cursor: pointer;
  box-shadow: 0 4px 18px rgba(3, 78, 162, 0.28);
}
.nudge-wrap::before {
  content: '';
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: conic-gradient(
    from 0deg,
    transparent 0deg,
    transparent 250deg,
    #f8ab10 305deg,
    #034ea2 350deg,
    transparent 360deg
  );
  animation: nudge-rotate 2.6s linear infinite;
}
.nudge-btn {
  position: relative;
  z-index: 1;
  display: inline-flex;
  align-items: center;
  border: none;
  outline: none;
  border-radius: 999px;
  padding: 11px 22px;
  background: #ffffff;
  color: #034ea2;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
}
.nudge-btn:hover {
  background: #f5f8fd;
}
@keyframes nudge-rotate {
  to {
    transform: rotate(360deg);
  }
}
@media (prefers-reduced-motion: reduce) {
  .nudge-wrap::before {
    animation: none;
  }
}
</style>

<!-- Non-scoped: v-dialog is teleported to the app root, so a scoped rule
     can't reach it. Namespaced by .recommendation-dialog to avoid leakage. -->
<style>
.recommendation-dialog {
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE/Edge */
}
.recommendation-dialog::-webkit-scrollbar {
  width: 0;
  height: 0;
}
</style>
